<template>
  <div class="login-page">
    <!-- 语言切换（右上角） -->
    <div class="lang">
      <span :class="{ on: curLang === 'km' }" @click="setLang('km')">ខ្មែរ</span>
      <span class="sep">|</span>
      <span :class="{ on: curLang === 'en' }" @click="setLang('en')">EN</span>
      <span class="sep">|</span>
      <span :class="{ on: curLang === 'zh' }" @click="setLang('zh')">中文</span>
    </div>

    <div class="login-container">
      <!-- PC 左侧装饰 -->
      <div class="side-decor pc-only left">
        <div class="decor-text">{{ $t('login.decorRight') }}</div>
        <img class="decor-img phone-img" :src="imgPhone" alt="phone" />
      </div>

      <!-- 中间登录面板 -->
      <div class="panel">
        <img class="logo" :src="imgLogo" alt="logo" />
        <img class="title-img" :src="imgTitle" alt="title" />

        <div class="form">
          <div class="label">{{ labelUsername }}</div>
          <div class="input-row">
            <div class="icon-circle"><i class="el-icon-user"></i></div>
            <input class="input" v-model.trim="username" autocomplete="username" placeholder="Username" />
          </div>

          <div class="label mt20">{{ labelPassword }}</div>
          <div class="input-row">
            <div class="icon-circle"><i class="el-icon-lock"></i></div>
            <input class="input" v-model="password" type="password" autocomplete="current-password" placeholder="Password" />
          </div>

          <div class="remember-row">
            <label class="remember">
              <input type="checkbox" v-model="remember" />
              <span>{{ labelRemember }}</span>
            </label>
          </div>

          <div class="button-group">
            <button class="btn login-btn" :disabled="loading" @click="onSubmit">
              {{ loading ? "..." : (curLang === 'km' ? 'ចូល' : $t("login.submit")) }}
            </button>
          </div>

          <div v-if="error" class="error">{{ error }}</div>
        </div>

        <!-- 手机端底部装饰（只在手机显示） -->
        <div class="mobile-decor mobile-only">
          <div class="m-img-row">
            <img class="m-img" :src="imgPhone" alt="phone" />
            <img class="m-img" :src="imgMoto" alt="moto" />
          </div>
        </div>
      </div>

      <!-- PC 右侧装饰 -->
      <div class="side-decor pc-only right">
        <div class="decor-text">{{ $t('login.decorLeft') }}</div>
        <img class="decor-img moto-img" :src="imgMoto" alt="moto" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      remember: true,
      loading: false,
      error: ""
    };
  },
  computed: {
    curLang() {
      return this.$i18n.locale;
    },
    // 图片
    imgLogo() { return require("@/assets/img/login-logo.png"); },
    imgTitle() { return require("@/assets/img/login.png"); },
    imgPhone() { return require("@/assets/img/phone.png"); },
    imgMoto() { return require("@/assets/img/moto.png"); },

    // 你要的“双语”：只有 km 模式显示 “高棉 | English”
    labelUsername() {
      if (this.curLang === "km") return "ឈ្មោះគណនី | Username";
      return this.$t("login.username");
    },
    labelPassword() {
      if (this.curLang === "km") return "លេខសម្ងាត់ | Password";
      return this.$t("login.password");
    },
    labelRemember() {
      if (this.curLang === "km") return "ចងចាំគណនី | remember me";
      return this.$t("login.remember");
    }
  },
  mounted() {
    this.$updateViewport('device-width');
  },
  methods: {
    onRegister() {
      this.$router.push("/register");
    },
    setLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
    },

    async onSubmit() {
      this.error = "";
      if (!this.username || !this.password) {
        this.error = this.$t("login.needInput");
        return;
      }

      try {
        this.loading = true;
        await this.$store.dispatch("auth/login", {
          username: this.username,
          password: this.password,
          remember: this.remember
        });
        this.$router.replace("/lotto");
      } catch (e) {
        this.error = (e && e._friendlyMessage) || e.message || "Login failed";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* 页面背景：干净的淡蓝色渐变 */
.login-page {
  min-height: 100vh;
  background: linear-gradient(to bottom, #a0c4de 0%, #d4e5f0 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
}

/* 顶部语言切换 */
.lang {
  position: absolute;
  top: 15px;
  right: 20px;
  z-index: 100;
  font-size: 13px;
  color: #1f5f8a;
}
.lang span { cursor: pointer; padding: 2px 5px; font-weight: 600; }
.lang span.on { font-weight: 900; text-decoration: underline; }
.sep { margin: 0 2px; opacity: 0.3; }

/* 整体容器：PC三栏布局 */
.login-container {
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
}

/* PC 侧边装饰栏 */
.side-decor {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 40px;
  gap: 30px;
  pointer-events: none;
}

.decor-text {
  font-size: 42px;
  font-weight: 900;
  color: #3c81ad;
  text-align: center;
  line-height: 1.2;
  font-family: Kh-Battambang, sans-serif;
  text-shadow: 0 2px 4px rgba(255,255,255,0.5);
}

.decor-img {
  max-width: 90%;
  filter: drop-shadow(0 15px 30px rgba(0,0,0,0.1));
}
.phone-img { width: 380px; }
.moto-img { width: 440px; }

/* 中间登录面板：参考样板站背景 */
.panel {
  width: 440px;
  height: 100%;
  background: rgba(126, 164, 188, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 40px;
  box-sizing: border-box;
  box-shadow: 0 0 50px rgba(0,0,0,0.05);
}

.logo {
  width: 160px;
  margin-bottom: 10px;
}

.title-img {
  width: 240px;
  margin-bottom: 50px;
}

.form { width: 100%; }

.label {
  font-size: 14px;
  color: #fff;
  font-weight: 700;
  margin-bottom: 8px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
}

.mt20 { margin-top: 25px; }

/* 输入胶囊 */
.input-row {
  height: 48px;
  border-radius: 24px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 5px;
  margin-bottom: 5px;
}

.icon-circle {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #0f5f8f;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 18px;
}

.input {
  border: 0;
  outline: none;
  background: transparent;
  flex: 1;
  font-size: 16px;
  color: #333;
}

.remember-row {
  margin-top: 15px;
  width: 100%;
}

.remember {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}

.button-group {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.login-btn {
  width: 140px;
  height: 44px;
  border-radius: 22px;
  border: 0;
  background: #0f5f8f;
  color: #fff;
  font-size: 20px;
  font-weight: 900;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
}

.login-btn:active { transform: scale(0.96); }

.error {
  margin-top: 20px;
  color: #ff4d4d;
  font-weight: 700;
  text-align: center;
}

/* 手机端样式 */
@media (max-width: 1100px) {
  .pc-only { display: none; }
  
  .login-container {
    height: auto;
    flex-direction: column;
    padding: 40px 20px;
  }

  .panel {
    width: 100%;
    max-width: 360px;
    height: auto;
    background: transparent;
    padding: 20px 0;
    box-shadow: none;
  }

  .label, .remember { color: #1f5f8a; text-shadow: none; }

  .mobile-decor {
    margin-top: 60px;
    width: 100%;
  }
  .m-text-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .m-text {
    font-size: 24px;
    font-weight: 900;
    color: #3c81ad;
    width: 45%;
    text-align: center;
    line-height: 1.2;
  }
  .m-img-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .m-img {
    width: 45%;
    object-fit: contain;
  }
}

@media (min-width: 1101px) {
  .mobile-only { display: none; }
}
</style>
